import i18n from '../../i18n';
import ValidationResult from '@common/interfaces/api/validation-result';

export const validateRobotName = (name: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-robot-name'),
  };
};

export const validateRobotSerialNumber = (serialNumber: string): ValidationResult => {
  if (serialNumber.length > 3 && (serialNumber.length !== 11 || !/^\d+$/.test(serialNumber))) {
    return {
      isValid: false,
      error: i18n.t('validation-error-invalid-serial-number'),
    };
  }
  return {
    isValid: true,
    error: i18n.t('form-help-text-robot-serial-number'),
  };
};

export const validateRobotUserPassword = (password: string): ValidationResult => {
  return {
    isValid: true,
    error: i18n.t('form-help-text-robot-user-password'),
  };
};

export const validateRobotServiceAdminPassword = (value: string): ValidationResult => {
  if (value.length !== 12) {
    return {
      isValid: false,
      error: i18n.t('validation-error-password-must-be-12-characters'),
    };
  }

  // Define patterns
  const numbersPattern = /[0-9]/g;
  const alphabetsPattern = /[A-Za-z]/g;
  const specialCharsPattern = /[.!?+\-*/_#"@(){}]/g; // Escaped special characters where needed

  // Find matches
  const numbers = value.match(numbersPattern) || [];
  const alphabets = value.match(alphabetsPattern) || [];
  const specialChars = value.match(specialCharsPattern) || [];

  // Validate counts
  if (numbers.length < 4) {
    return {
      isValid: false,
      error: i18n.t('validation-error-password-must-have-4-numbers'),
    };
  }
  if (alphabets.length < 4) {
    return {
      isValid: false,
      error: i18n.t('validation-error-password-error-must-have-4-letters'),
    };
  }
  if (specialChars.length < 2) {
    return {
      isValid: false,
      error: i18n.t('validation-error-password-must-have-2-special-characters'),
    };
  }

  return {
    isValid: true,
    error: i18n.t('form-help-text-robot-service-admin-password'),
  };
};
